import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './ErrorBoundary.tsx';
import './styles.css';

/*
 * Bring in the webfont the non-blocking way, without an inline event handler.
 *
 * index.html requests the Google stylesheet with `media="print"` so it never blocks the
 * first paint, and something has to flip it to `all` once it is in. That used to be an
 * `onload="this.media='all'"` attribute on the <link>, which is inline SCRIPT as far as
 * the Content-Security-Policy is concerned - keeping it would have forced script-src
 * 'unsafe-inline' site-wide, which is most of what the policy exists to prevent.
 *
 * Set directly rather than behind a load listener: by the time this module runs the sheet
 * has usually arrived already and its load event has been and gone, so a listener would
 * wait for an event that never fires again. Assigning the media query is idempotent and
 * applies whenever the bytes land.
 */
for (const link of document.querySelectorAll<HTMLLinkElement>('link[data-font-swap]')) {
  link.media = 'all';
}

createRoot(document.getElementById('root')!).render(
  <StrictMode><ErrorBoundary><App /></ErrorBoundary></StrictMode>,
);
